import i18n from '@/lang'

export const ownModelRating = [
  {
    label: 'A',
    value: 'A'
  },
  {
    label: 'B',
    value: 'B'
  },
  {
    label: 'C',
    value: 'C'
  },
  {
    label: 'D',
    value: 'D'
  }
]

export const isFinished = [
  {
    label: i18n.t('Belum lunas'), // Outstanding
    value: '0'
  },
  {
    label: i18n.t('Pelunasan'), // Settled
    value: '1'
  }
]

export const repayment = [
  {
    label: i18n.t('Telah pembayaran'), // Repaid
    value: '1'
  },
  {
    label: i18n.t('Belum pembayaran'), // Not repaid
    value: '2'
  },
  {
    label: i18n.t('Telah jatuh tempo'), // Overdue
    value: '3'
  }
]

export const isEnsured = [
  {
    label: i18n.t('Belum berasuransi'), // Uninsured
    value: '0'
  },
  {
    label: i18n.t('Telah berasuransi'), // Insured
    value: '1'
  }
]

export const loanStatus = [
  {
    label: i18n.t('Pencairan'), // Disbursed
    value: '1'
  },
  {
    label: i18n.t('Pelunasan'), // Settled
    value: '2'
  },
  {
    label: i18n.t('Pelunasan manual'), // Write off
    value: '3'
  },
  {
    label: i18n.t('Membatalkan'), // Cancel
    value: '4'
  },
  {
    label: i18n.t('Pencairan gagal'), // Loan failed
    value: '5'
  },
  {
    label: i18n.t('Dalam pencairan'), // Loan in progress
    value: '7'
  },
  {
    label: i18n.t('Menunggu pembelian target'), // Awaiting bids
    value: '8'
  },
  {
    label: i18n.t('Pembelian target'), // Bid
    value: '14'
  }
]

export const repaymentStatus = [
  {
    label: i18n.t('Telah pembayaran'),
    value: '1'
  },
  {
    label: i18n.t('Belum pembayaran'),
    value: '2'
  },
  {
    label: i18n.t('Telah jatuh tempo'),
    value: '3'
  }
]

export const genderRDL = [
  {
    label: i18n.t('Laki-laki'), // Male
    value: '0'
  },
  {
    label: i18n.t('Perempuan'), // Female
    value: '1'
  }
]

export const gender = [
  {
    label: i18n.t('Laki-laki'),
    value: '1'
  },
  {
    label: i18n.t('Perempuan'),
    value: '2'
  }
]

export const riskLevelLabels = [
  {
    label: i18n.t('Risiko Rendah'),
    value: '1'
  },
  {
    label: i18n.t('Risiko Rendah'),
    value: '2'
  },
  {
    label: i18n.t('Risiko Rendah'),
    value: '3'
  },
  {
    label: i18n.t('Risiko Sedang'),
    value: '4'
  },
  {
    label: i18n.t('Risiko Rendah'),
    value: '5'
  },
  {
    label: i18n.t('Risiko Rendah'),
    value: '6'
  },
  {
    label: i18n.t('Risiko Tinggi'),
    value: '7'
  },
  {
    label: i18n.t('Risiko Tinggi'),
    value: '8'
  }
]

export const lengthOfStay = [
  {
    label: i18n.t('3 Bulan'),
    value: '0'
  },
  {
    label: i18n.t('6 Bulan'),
    value: '1'
  },
  {
    label: i18n.t('1 Tahun'),
    value: '2'
  },
  {
    label: i18n.t('2 Tahun'),
    value: '3'
  },
  {
    label: i18n.t('> 2 Tahun'),
    value: '4'
  }
]

export const lengthOfWorking = [
  {
    label: i18n.t('Pelajar atau Belum Pernah Bekerja'),
    value: 0
  },
  {
    label: i18n.t('< 1 Tahun'),
    value: 1
  },
  {
    label: i18n.t('1 s.d < 2 Tahun'),
    value: 2
  },
  {
    label: i18n.t('2 s.d 3 Tahun'),
    value: 3
  },
  {
    label: i18n.t('> 3 Tahun'),
    value: 4
  }
]

export const borrowerGender = [
  {
    label: i18n.t('Perempuan'),
    value: '0'
  },
  {
    label: i18n.t('Laki-laki'),
    value: '1'
  }
]

export const education = [
  {
    label: i18n.t('SD'),
    value: '01'
  },
  {
    label: i18n.t('SMP'),
    value: '02'
  },
  {
    label: i18n.t('SMA / Sederajat'),
    value: '03'
  },
  {
    label: i18n.t('Akademi/Diploma'),
    value: '04'
  },
  {
    label: i18n.t('S1'),
    value: '05'
  },
  {
    label: i18n.t('S2'),
    value: '06'
  },
  {
    label: i18n.t('S3'),
    value: '07'
  }
]

export const religion = [
  {
    label: i18n.t('Islam'),
    value: '1'
  },
  {
    label: i18n.t('Kristen'),
    value: '2'
  },
  {
    label: i18n.t('Katolik'),
    value: '3'
  },
  {
    label: i18n.t('Budha'),
    value: '4'
  },
  {
    label: i18n.t('Hindu'),
    value: '5'
  },
  {
    label: i18n.t('Kong Hu Chu'),
    value: '6'
  },
  {
    label: i18n.t('Other religion'),
    value: '7'
  }
]

export const job = [
  {
    label: i18n.t('Pegawai Negeri'),
    value: '01'
  },
  {
    label: i18n.t('Pegawai Swasta'),
    value: '02'
  },
  {
    label: i18n.t('Pegawai BUMN/BUMD'),
    value: '03'
  },
  {
    label: i18n.t('TNI/POLRI'),
    value: '04'
  },
  {
    label: i18n.t('Pengusaha'),
    value: '05'
  },
  {
    label: i18n.t('Pedagang'),
    value: '06'
  },
  {
    label: i18n.t('Petani/Nelayan'),
    value: '07'
  },
  {
    label: i18n.t('Pelajar/Mahasiswa'),
    value: '08'
  },
  {
    label: i18n.t('Ibu Rumah Tangga'),
    value: '09'
  },
  {
    label: i18n.t('Tidak Bekerja'),
    value: '10'
  },
  {
    label: i18n.t('Karyawan/Karyawati'),
    value: '11'
  },
  {
    label: i18n.t('Wiraswasta'),
    value: '12'
  },
  {
    label: i18n.t('Pejabat Negara'),
    value: '13'
  },
  {
    label: i18n.t('Akuntan'),
    value: '14'
  },
  {
    label: i18n.t('Pengacara/Notaris'),
    value: '15'
  },
  {
    label: i18n.t('Profesi'),
    value: '16'
  },
  {
    label: i18n.t('Pensiunan'),
    value: '17'
  },
  {
    label: i18n.t('Dosen/Guru Swasta'),
    value: '18'
  },
  {
    label: i18n.t('Dosen/Guru Negeri'),
    value: '19'
  },
  {
    label: i18n.t('Dokter'),
    value: '20'
  },
  {
    label: i18n.t('Pegawai BNI'),
    value: '21'
  },
  {
    label: i18n.t('Unit Afiliasi BNI'),
    value: '22'
  },
  {
    label: i18n.t('Lain-lain'),
    value: '99'
  }
]

export const monthlyIncome = [
  {
    label: i18n.t('Monthly income less than IDR 3 million'),
    value: '2000000'
  },
  {
    label: i18n.t('Monthly income between IDR 3 up to 5 million'),
    value: '4000000'
  },
  {
    label: i18n.t('Monthly income between IDR 5 up to 10 million'),
    value: '8000000'
  },
  {
    label: i18n.t('Monthly income between IDR 10 up to 20 million'),
    value: '15000000'
  },
  {
    label: i18n.t('Monthly income between IDR 20 up to 50 million'),
    value: '44000000'
  },
  {
    label: i18n.t('Monthly income between IDR 50 up to 100 million'),
    value: '88000000'
  },
  {
    label: i18n.t('Monthly income between IDR 100 up to 500 million'),
    value: '325000000'
  },
  {
    label: i18n.t('Monthly income more than IDR 500 million'),
    value: '725000000'
  }
]

export const married = [
  {
    label: i18n.t('Lajang(Single)'),
    value: 'L'
  },
  {
    label: i18n.t('Menikah(Married)'),
    value: 'M'
  },
  {
    label: i18n.t('Duda(Widower)'),
    value: 'J'
  },
  {
    label: i18n.t('Janda(Widow)'),
    value: 'D'
  }
]

export const title = [
  {
    label: i18n.t('Bpk'),
    value: '01'
  },
  {
    label: i18n.t('Ibu'),
    value: '02'
  },
  {
    label: i18n.t('Sdr'),
    value: '03'
  },
  {
    label: i18n.t('Sdri'),
    value: '04'
  },
  {
    label: i18n.t('Blank'),
    value: '99'
  }
]

export const fundChannel = [
  {
    label: '1',
    value: 'accepted by bnc',
    mid: 10010
  },
  {
    label: '2',
    value: 'accepted by bss',
    mid: 10011
  },
  {
    label: '3',
    value: 'accepted by weshare',
    mid: 10012
  },
  {
    label: '4',
    value: 'accepted by geerong',
    mid: 10013
  },
  {
    label: '6',
    value: 'WESHARE2',
    mid: 10014
  },
  {
    label: '7',
    value: 'accepted by finovary',
    mid: 10015
  },
  {
    label: '11',
    value: 'Superbank',
    mid: 10019
  },
  {
    label: '10',
    value: 'alto peak',
    mid: 10018
  }
]
